/* FERRY AUTO-GENERATED: DO NOT EDIT THIS FILE */ /* eslint-disable */ // @ts-nocheck
import { ferryFetch } from "@ecom-alliance/libs";
import * as api from "../../api";
import * as image from "../../common/image";
import * as video from "../../common/video";
import * as quota from "../data/quota";
import * as invitation from "../data/invitation";
export { api, image, video, quota, invitation };
import { headers } from "../../_util";
export var AffiliateCreatorProfileSortingAlgorithm = {
  AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_ALGO_RECOMMENDATION: 1,
  AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_ALGO_FOLLOWER_CNT_ASCENDING: 2,
  AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_ALGO_FOLLOWER_CNT_DESCENDING: 3,
  AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_ALGO_VIDEO_AVG_VIEW_DESCENDING: 5,
  AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_ALGO_VIDEO_AVG_VIEW_ASCENDING: 4,
  AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_ALGO_VIDEO_PUBLISH_CNT_DESCENDING: 7,
  AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_ALGO_LIVE_AVG_VIEW_DESCENDING: 8,
  AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_ALGO_LIVE_AVG_VIEW_ASCENDING: 9,
  AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_GMV_DESCENDING: 10,
  AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_GMV_ASCENDING: 11,
  AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_ALGO_EC_VIDEO_AVG_VIEW_DESCENDING: 12,
  AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_ALGO_EC_VIDEO_AVG_VIEW_ASCENDING: 13,
  AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_VIDEO_GPM_DESCENDING: 14,
  AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_VIDEO_GPM_ASCENDING: 15,
  AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_LIVE_GPM_DESCENDING: 16,
  AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_LIVE_GPM_ASCENDING: 17,
  AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_GMV_REVENUE_DESCENDING: 18,
  AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_GMV_REVENUE_ASCENDING: 19,
  AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_UNITS_SOLD_DESCENDING: 20,
  AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_UNITS_SOLD_ASCENDING: 21,
  AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_AVG_ENGAGEMENT_RATE_DESCENDING: 22,
  AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_AVG_ENGAGEMENT_RATE_ASCENDING: 23,
  AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_ALGO_VIDEO_MED_VIEW_DESCENDING: 24,
  AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_ALGO_VIDEO_MED_VIEW_ASCENDING: 25,
  AFFILIATE_CREATOR_SEARCH_PROFILE_SORTING_ALGO_FOLLOWER_CNT_V2_DESCENDING: 26
};
export var ContentPreferenceType = {
  VIDEO: 1,
  LIVE: 2
};
export var CreatorScoreType = {
  AMONG_10_19: 1,
  AMONG_20_29: 2,
  AMONG_30_39: 3,
  ABOVE_40: 4
};
export var AgeGroup = {
  AGE_GROUP_18_24: 1,
  AGE_GROUP_25_34: 2,
  AGE_GROUP_GT_34: 3,
  AGE_GROUP_35_44: 4,
  AGE_GROUP_45_54: 5,
  AGE_GROUP_GT_55: 6
};
export var Gender = {
  GENDER_UNKNOWN: 1,
  GENDER_MALE: 2,
  GENDER_FEMALE: 3
};
export var GMVGroup = {
  GMV_GROUP_RANGE_1: 1,
  GMV_GROUP_RANGE_2: 2,
  GMV_GROUP_RANGE_3: 3,
  GMV_GROUP_RANGE_4: 4,
  GMV_GROUP_RANGE_0_50K: 5,
  GMV_GROUP_RANGE_50K_100K: 6,
  GMV_GROUP_RANGE_100K_500K: 7,
  GMV_GROUP_RANGE_500K_1M: 8,
  GMV_GROUP_RANGE_1M_INF: 9
};
export var UnitsSoldGroup = {
  UNITS_SOLD_GROUP_0_10: 1,
  UNITS_SOLD_GROUP_10_100: 2,
  UNITS_SOLD_GROUP_100_1000: 3,
  UNITS_SOLD_GROUP_GT_1000: 4
};
export var CommissionRateGroup = {
  COMMISSION_GROUP_NO_THRESHOLD: 0,
  COMMISSION_GROUP_LT_5_PERCENTAGE: 1,
  COMMISSION_GROUP_LT_10_PERCENTAGE: 2,
  COMMISSION_GROUP_LT_15_PERCENTAGE: 3,
  COMMISSION_GROUP_LT_20_PERCENTAGE: 4
};
export var TimeRangePeriod = {
  LIFETIME: 1,
  CUSTOMIZED: 2,
  TODAY: 10,
  CURRENT_WEEK: 11,
  CURRENT_MONTH: 12,
  CURRENT_WEEK_MON_SUN: 13,
  YESTERDAY: 20,
  PAST_WEEK: 21,
  PAST_MONTH: 22,
  PAST_WEEK_MON_SUN: 23,
  PAST_2_DAYS: 30,
  PAST_7_DAYS: 31,
  PAST_14_DAYS: 32,
  PAST_28_DAYS: 33,
  PAST_56_DAYS: 34,
  PAST_30_DAYS: 40,
  PAST_60_DAYS: 41,
  PAST_2_WEEKS: 50,
  PAST_2_WEEKS_MON_SUN: 51,
  PAST_2_MONTHS: 60,
  TODAY_PLUS_ONE: 100,
  YESTERDAY_PLUS_ONE: 101
};
export var TimeRangeGranularity = {
  ALL: 1,
  SO_FAR: 2,
  HOURLY: 10,
  DAILY: 11,
  WEEKLY: 12,
  MONTHLY: 13,
  MINUTE_1: 20,
  MINUTE_5: 21,
  MINUTE_10: 22,
  MINUTE_15: 23,
  MINUTE_30: 24,
  DAYS_7: 30,
  DAYS_14: 31,
  DAYS_28: 32,
  DAYS_30: 40
};
export var CreatorLevel = {
  CreatorLevel_ALL: 100,
  CreatorLevel_Level_0: 0,
  CreatorLevel_Level_1: 1,
  CreatorLevel_Level_2: 2,
  CreatorLevel_Level_3: 3,
  CreatorLevel_Level_4: 4,
  CreatorLevel_Level_5: 5,
  CreatorLevel_Level_6: 6,
  CreatorLevel_Level_7: 7,
  CreatorLevel_Level_8: 8
};
export var SortingDirection = {
  ASCENDING: 1,
  DESCENDING: 2
};
export var AffiliateCreatorDataAggregationType = {
  AFFILIATE_CREATOR_DATA_AGGREGATION_ALL: 1,
  AFFILIATE_CREATOR_DATA_AGGREGATION_ECOM: 2
};
export var AffiliateCreatorVideoAggregationType = {
  AFFILIATE_CREATOR_VIDEO_AGGREGATION_ALL: 1,
  AFFILIATE_CREATOR_VIDEO_AGGREGATION_ECOM: 2
};
export var ManagedByAgencyType = {
  YES: 1,
  NO: 2
};
export var FollowerSizeGroup = {
  FOLLOWER_SIZE_0_10K: 1,
  FOLLOWER_SIZE_10K_100K: 2,
  FOLLOWER_SIZE_100K_1M: 3,
  FOLLOWER_SIZE_1M_10M: 4,
  FOLLOWER_SIZE_GT_10M: 5
};
export var AvgVideoViewsGroup = {
  AVG_VIDEO_VIEWS_NO_THRESHOLD: 1,
  AVG_VIDEO_VIEWS_GT_100: 2,
  AVG_VIDEO_VIEWS_GT_10K: 3,
  AVG_VIDEO_VIEWS_GT_100K: 4
};
export var AvgLiveViewsGroup = {
  AVG_LIVE_VIEWS_NO_THRESHOLD: 1,
  AVG_LIVE_VIEWS_GT_100: 2,
  AVG_LIVE_VIEWS_GT_10K: 3,
  AVG_LIVE_VIEWS_GT_100K: 4
};
export var VideoEngagementRateGroup = {
  VIDEO_ENGAGEMENT_RATE_NO_THRESHOLD: 1,
  VIDEO_ENGAGEMENT_RATE_GT_5_PERCENT: 2,
  VIDEO_ENGAGEMENT_RATE_GT_10_PERCENT: 3,
  VIDEO_ENGAGEMENT_RATE_GT_20_PERCENT: 4
};
export var Cooperation = {
  UNSPECIFIED: 0,
  FIXED_RATE: 1,
  COMMISSION_RATE: 2
};
export var ContactInfoFieldType = {
  ContactInfoFieldType_UNSPECIFIED: 0,
  WHATS_APP: 1,
  EMAIL: 2,
  SELLER_WHATS_APP: 3,
  SELLER_EMAIL: 4,
  SELLER_IM_SCHEMA: 5,
  SELLER_INVITATION_WHATS_APP: 6,
  SELLER_INVITATION_EMAIL: 7,
  SELLER_WHATS_APP_COUNTRY_CODE: 8,
  CREATOR_WHATS_APP_COUNTRY_CODE: 9,
  SELLER_INVITATION_WHATS_APP_COUNTRY_CODE: 10,
  SELLER_LINE: 21,
  SELLER_ZALO: 22,
  SELLER_VIBER: 23,
  SELLER_FACEBOOK: 24,
  CREATOR_LINE: 31,
  CREATOR_ZALO: 32,
  CREATOR_VIBER: 33,
  CREATOR_FACEBOOK: 34,
  SELLER_INVITATION_LINE: 41,
  SELLER_INVITATION_ZALO: 42,
  SELLER_INVITATION_VIBER: 43,
  SELLER_INVITATION_FACEBOOK: 44,
  SELLER_INVITATION_TELEGRAM: 45,
  SELLER_INVITATION_PHONE: 46,
  SELLER_LINE_COUNTRY_CODE: 51,
  SELLER_ZALO_COUNTRY_CODE: 52,
  SELLER_VIBER_COUNTRY_CODE: 53,
  CREATOR_LINE_COUNTRY_CODE: 61,
  CREATOR_ZALO_COUNTRY_CODE: 62,
  CREATOR_VIBER_COUNTRY_CODE: 63,
  SELLER_INVITATION_LINE_COUNTRY_CODE: 71,
  SELLER_INVITATION_ZALO_COUNTRY_CODE: 72,
  SELLER_INVITATION_VIBER_COUNTRY_CODE: 73,
  SELLER_INVITATION_TELEGRAM_COUNTRY_CODE: 74,
  SELLER_INVITATION_PHONE_COUNTRY_CODE: 75
};
export var ModuleType = {
  Module_UNSPECIFIED: 0,
  Module_CORE: 1,
  Module_LIVE: 2,
  Module_VIDEO: 3,
  Module_CONTENT_TREND_EC: 4,
  Module_FOLLOWER: 5,
  Module_CONTENT_TREND_ALL: 6
};
export var VideoProductStatus = {
  VideoProductStatus_Valid: 1,
  VideoProductStatus_Invalid: 2
};
export var SugScene = {
  SUGSCENE_DEFAULT: 0,
  SUGSCENE_CMP: 1
};
export var CreatorQueryType = {
  QUERY_DEFAULT: 0,
  MANUAL: 1,
  PRODUCT_HINT: 2,
  CONTENT_HINT: 3,
  CREATOR_SUG: 4,
  PRODUCT_SUG: 5,
  CONTENT_SUG: 6,
  SIMILAR_CREATOR: 1000
};
export var GMVRank = {
  TOP20PCT: 1,
  TOP40PCT: 2,
  TOP60PCT: 3,
  TOP_OTHER: 4
};
export var RankType = {
  PROMOTION_EFFICIENCY: 1,
  FAST_GROWING: 2,
  POPULAR_CONTENT: 3,
  DILIGENT_PROMOTION: 4,
  ACTIVE_COOPERATION: 5
};
export var RankPeriod = {
  RANK_DAILY: 1,
  RANK_WEEKLY: 2,
  RANK_MONTHLY: 3
};
export var RankContentType = {
  CONTENT_ALL: 1,
  CONTENT_LIVE: 2,
  CONTENT_VIDEO: 3
};
export var FieldStatus = {
  NORMAL: 0,
  UN_AUTHORIZED: 1,
  FILTER_BY_ACCU: 2,
  FILTER_BY_A1_CREATOR: 3,
  INTERNAL_ERR: 99
};
export var PositionChangeType = {
  POSITION_UP: 1,
  POSITION_DOWN: 2,
  POSITION_SAME: 3,
  POSITION_NEW: 4
};
export var CreatorLabelEnum = {
  BEST_SELLER: 1,
  TIMELY_COMPLIANCE: 2,
  QUICK_RESPONSE: 3,
  FREQUENTLY_POST: 4
};
export var CreatorLabelRank = {
  RANK_TOP5PCT: 1,
  RANK_TOP10PCT: 2,
  RANK_TOP15PCT: 3,
  RANK_TOP20PCT: 4,
  RANK_NOT_AUTHORIZED: 100,
  RANK_OTHERS: 101
};
export var WishListUpdateType = {
  WL_TYPE_UNKNOW: 0,
  WL_TYPE_ADD: 1,
  WL_TYPE_REMOVE: 2
};
export var CreatorSortField = {
  DEFAULT: 0,
  GMV_28D: 1,
  HAS_CONTACT_INFO: 2,
  FOLLOWERS_CNT: 3,
  VIDEO_PUBLISH_CNT: 4,
  VIDEO_AVG_VIEW_CNT: 5,
  LIVE_WATCH_UV: 6,
  GMV_30D: 7,
  VIDEO_GPM: 9,
  LIVE_GPM: 10
};
export var SortOrder = {
  ASC: 0,
  DESC: 1
};
export var CmpShopFilterEnum = {
  STAR_CREATOR: 1
};
export var OptionType = {
  OPTION_UNKNOWN: 0,
  OPTION_BRAND: 1,
  OPTION_CATEGORY: 2,
  OPTION_GMV: 3,
  OPTION_SORTER: 4,
  OPTION_CREATOR_LEVEL: 5
};
export var ProfileType = {
  PROFILE_UNKNOWN: 0,
  PROFILE_BASIC: 1,
  PROFILE_PERFORMANCE: 2,
  PROFILE_PORTRAIT: 3,
  PROFILE_TREND: 4,
  PROFILE_VIDEO: 5,
  PROFILE_PARTNER: 6
};
export var CreatorPermissionTag = {
  A1: 1,
  A2: 2,
  Other: 3
};
export var RecommendScene = {
  REC_SCENE_DEFAULT: 0,
  REC_SCENE_CMP_FEED: 1,
  REC_SCENE_CMP_HOMEPAGE: 2,
  REC_SCENE_CMP_PARTNER: 3
};
export var MatchingStrategy = {
  Overall: 1,
  Content: 2,
  FansSuborder: 3,
  FansBrowse: 4,
  PurchaseGroup: 5
};
export var SampleFulfillmentRateGroupFilter = {
  SAMPLE_FULFILLMENT_RATE_OPTION_ALL: 1,
  SAMPLE_FULFILLMENT_RATE_OPTION_OK: 2,
  SAMPLE_FULFILLMENT_RATE_OPTION_GOOD: 3,
  SAMPLE_FULFILLMENT_RATE_OPTION_BETTER: 4
};
export var ShopSettingType = {
  SETTING_TYPE_PERSONALIZED_RECOMMENDATIONS: 1
};
export var SorterStatus = {
  SORTER_STATUS_NORMAL: 0,
  SORTER_STATUS_DISABLED: 10,
  SORTER_STATUS_HIDDEN: 20
};
export var AffiliateCreatorMarketPlaceApi = /*#__PURE__*/function () {
  function AffiliateCreatorMarketPlaceApi(uriPrefix) {
    this.uriPrefix = typeof uriPrefix !== "undefined" ? uriPrefix : "";
  }
  var _proto = AffiliateCreatorMarketPlaceApi.prototype;
  _proto.GetAffiliateCreatorRecommendationQuery = function GetAffiliateCreatorRecommendationQuery(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/marketplace/recommendation";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetAffiliateCreatorSearchQuery = function GetAffiliateCreatorSearchQuery(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/marketplace/search";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetAffiliateCreatorSearchSuggestionsQuery = function GetAffiliateCreatorSearchSuggestionsQuery(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/insights/affiliate/creator/search/suggestions";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetAffiliateCreatorProfileStatsQuery = function GetAffiliateCreatorProfileStatsQuery(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/marketplace/creator/profile/stats";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetAffiliateCreatorCoreStatsQuery = function GetAffiliateCreatorCoreStatsQuery(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/cmp/creator/ec/stats";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetAffiliateCreatorContentStatsQuery = function GetAffiliateCreatorContentStatsQuery(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/marketplace/content/stats";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetAffiliateCreatorFollowerStatsQuery = function GetAffiliateCreatorFollowerStatsQuery(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/marketplace/follower/stats";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetAffiliateCreatorVideoListQuery = function GetAffiliateCreatorVideoListQuery(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/insights/affiliate/creator/video/list";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateCreatorMCNInfo = function AffiliateCreatorMCNInfo(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/marketplace/mcn/info";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateShopInviteGet = function AffiliateShopInviteGet(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/cmp/shop/invite/get";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateShopInviteSend = function AffiliateShopInviteSend(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/cmp/shop/invite/send";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetShopInviteList = function GetShopInviteList(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/cmp/shop/invite/list/get";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetAffiliateCreatorMainIndustryQuery = function GetAffiliateCreatorMainIndustryQuery(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/cmp/main/industries";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetAffiliateCreatorRankList = function GetAffiliateCreatorRankList(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/cmp/creator/rank/list/get";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateGuidancePageCreatorRecommendation = function AffiliateGuidancePageCreatorRecommendation(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/guidance_page/creator_recommendation";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateGuidancePageCreatorFansPortrait = function AffiliateGuidancePageCreatorFansPortrait(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/guidance_page/creator_fans_portrait";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.MGetAffiliateGuidancePageCreatorStats = function MGetAffiliateGuidancePageCreatorStats(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/guidance_page/creator_stats";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.SearchCreatorInWishList = function SearchCreatorInWishList(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/wish_list/search/creator";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.UpdateSellerWishList = function UpdateSellerWishList(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/seller/wish_list/update/creator";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetCmpShopFilter = function GetCmpShopFilter(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/cmp/filter";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.FindAffiliateCreator = function FindAffiliateCreator(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/marketplace/find";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.ListAffiliateCmpOptions = function ListAffiliateCmpOptions(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/marketplace/option";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetCreatorProfile = function GetCreatorProfile(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/marketplace/profile";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.AffiliateInvitationRecommendCreator = function AffiliateInvitationRecommendCreator(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/creator/marketplace/invitation_recommend_creator";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.GetShopSettings = function GetShopSettings(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/shop/settings/get";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  _proto.UpdateShopSetting = function UpdateShopSetting(request, option) {
    var uri = this.uriPrefix + "/api/v" + (request.version || "1") + "/oec/affiliate/shop/settings/update";
    var body = request;
    return ferryFetch(uri, {
      method: "POST",
      headers: headers,
      body: body
    }, option);
  };
  return AffiliateCreatorMarketPlaceApi;
}();
export var affiliateCreatorMarketPlaceApiClient = new AffiliateCreatorMarketPlaceApi();